<template>
	<div class="app" :class="{'device-money-default': themeCode === 'default', 'device-money': themeCode === 'blue'}">
		<div class="energy-content-r-top">
      <div>
        <Select v-model="SelectData" style="width:10vw;">
          <Option value ="1">{{ $t('deviceMoney.deviceMoney.560758-0') }}</Option>
          <Option value ="2">{{ $t('deviceMoney.deviceMoney.560758-1') }}</Option>
        </Select>
      </div>
		  <div>
		    <DatePicker v-model="times" format="yyyy-MM-dd" type="daterange" placement="bottom-end" :placeholder="$t('deviceMoney.deviceMoney.560758-2')" style="width: 10vw"></DatePicker>
		  </div>
      <div>
        <Input v-model="mobilPhone" clearable :placeholder="$t('deviceMoney.deviceMoney.560758-3')"></Input>
      </div>
      <div>
        <Input v-model="deviceCode" clearable :placeholder="$t('deviceMoney.deviceMoney.560758-5')"></Input>
      </div>
      <div>
        <Input v-model="userDeviceName" clearable :placeholder="$t('deviceMoney.deviceMoney.560758-6')"></Input>
      </div>
		  <div>
		    <Button type="primary" @click="inquireClick">{{ $t('deviceMoney.deviceMoney.560758-7') }}</Button>
		  </div>
		  <div>
		    <Button type="success" @click="exportClickOne">{{ $t('deviceMoney.deviceMoney.560758-8') }}</Button>
		  </div>
		</div>
    <div class="energy-content-r-content" v-if="SelectData == 1">
      <dv-border-box-10 :color="themeCode === 'default' ? ['#46758b', '#46857b'] : ['#092768', '#28449D']" :backgroundColor="themeCode === 'default' ? 'rgba(83,134,123,0.5)' : 'rgba(2,10,57,0.3)'">
        <div class="energy-ranking">
          <div class="map-bottom-content-tab">
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-3') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-9') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-6') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-5') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-10') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-11') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-12') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-13') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-14') }}</div>
          </div>
          <div class="map-bottom-list">
            <div class="map-bottom-lists" v-if="DeviceOperateLists.length > 0">
              <div class="map-bottom-list-item" v-for="(item) in DeviceOperateLists" :key="item.Id">
                <div class="map-bottom-list-item-device">{{item.MobilePhone}}</div>
                <div class="map-bottom-list-item-device">{{item.UserName}}</div>
                <div class="map-bottom-list-item-addr">{{item.UserDeviceName}}</div>
                <div class="map-bottom-list-item-date">{{item.DeviceCode}}</div>
                <div class="map-bottom-list-item-date">{{item.TradeAmount}}</div>
                <div class="map-bottom-list-item-date">{{item.LastBalance}}</div>
                <div class="map-bottom-list-item-date">{{item.NowBalance}}</div>
                <div class="map-bottom-list-item-device">{{item.OrderCode}}</div>
                <div class="map-bottom-list-item-device">{{item.AddTime}}</div>
              </div>
            </div>
            <div v-else class="map-right-group-list-none">{{ $t('deviceMoney.deviceMoney.560758-15') }}</div>
          </div>
          <div class="user-top-list-page">
            <Page :total="TotalCount"
            :current="pageIndex"
            :page-size="pageSize"
            @on-change="DeviceChange"
            @on-page-size-change="DeviceSizeChange"
            size="small" show-elevator show-sizer placement="top" show-total/>
          </div>
        </div>
      </dv-border-box-10>
    </div>

    <div class="energy-content-r-content" v-if="SelectData == 2">
      <dv-border-box-10>
        <div class="energy-ranking">
          <div class="map-bottom-content-tab">
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-3') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-9') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-6') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-5') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-16') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-17') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-18') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-19') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-20') }}</div>
            <div class="map-bottom-content-tab-item">{{ $t('deviceMoney.deviceMoney.560758-21') }}</div>
          </div>
          <div class="map-bottom-list">
            <div class="map-bottom-lists" v-if="GetUserDeviceElecFeeLogData.length > 0">
              <div class="map-bottom-list-item" v-for="(item) in GetUserDeviceElecFeeLogData" :key="item.Id">
                <div class="map-bottom-list-item-device">{{item.MobilePhone}}</div>
                <div class="map-bottom-list-item-device">{{item.UserName}}</div>
                <div class="map-bottom-list-item-addr">{{item.UserDeviceName}}</div>
                <div class="map-bottom-list-item-date">{{item.DeviceCode}}</div>
                <div class="map-bottom-list-item-device">{{item.EPrice}}</div>
                <div class="map-bottom-list-item-device">{{item.ETotalToday}}</div>
                <div class="map-bottom-list-item-device">{{item.ETotalAmountToday}}</div>
                <div class="map-bottom-list-item-device">{{item.xianDianSunHaoDianLiangToday}}</div>
                <div class="map-bottom-list-item-device">{{item.gongTanDianLiangToday}}</div>
                <div class="map-bottom-list-item-date">{{item.UpdateTime}}</div>
              </div>
            </div>
            <div v-else class="map-right-group-list-none">{{ $t('deviceMoney.deviceMoney.560758-15') }}</div>
          </div>
          <div class="user-top-list-page">
            <Page :total="TotalCount2"
            :current="pageIndex2"
            :page-size="pageSize2"
            @on-change="DeviceChange2"
            @on-page-size-change="DeviceSizeChange2"
            size="small" show-elevator show-sizer placement="top" />
          </div>
        </div>
      </dv-border-box-10>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import api from '../../../api/request.js'
	export default {
		data() {
			return {
        times: [],
        deviceCode: '',
        userDeviceName: '',
        mobilPhone: '',
        pageIndex: 1,
        pageSize: 20,
        pageIndex2: 1,
        pageSize2: 20,
        DeviceOperateLists: [],
        TotalCount: 0,
        TotalCount2: 0,
        SelectData:'1',
        GetUserDeviceElecFeeLogData:[],   //设备电费明细
			  themeCode: '',

      }
    },

    created() {
			let _this = this;
			_this.themeCode = _this.$store.getters.getThemeCode;
		},

		computed: {

		},

    filters: {
      initDate(value) {
        if (!value) return '';
        let list = value.split(' ');
        return list[0];
      },
    },

		mounted() {
      let _this = this;
      // 获取当天时间
      _this.getTiemDate();
      // 获取用户设备操作日志
      _this.GetUserDeviceOperate();
      _this.GetUserDeviceElecFeeLogs();
		},

		methods: {
      GetUserDeviceElecFeeLogs() {
        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }
        let _this = this,
          AdminData = JSON.parse(Cookies.get('AdminData')),
          startDt = '',
          endDt = '';

        if (_this.times.length > 0) {
          startDt = _this.formDate(_this.times[0]);
          endDt = _this.formDate(_this.times[1])
        };
        // /api/YhjStatic/GetUserDeviceElecFeeLog
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/GetUserDeviceElecFeeLog?isAdmin=${AdminData.IsAdmin}&groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.pageIndex2}&pageSize=${_this.pageSize2}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCode}&userDeviceName=${_this.userDeviceName}&mobilPhone=${_this.mobilPhone}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          if (res.Success) {
            _this.GetUserDeviceElecFeeLogData = res.Data;
            _this.TotalCount2 = res.TotalCount;
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },

      // 获取当天时间
      getTiemDate() {
        //api/YhjStatic/GetUserDevicePayLog
        let _this = this;
        var date = new Date();
        date.setMonth(date.getMonth()-1);
        var dateString = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

        var dates = new Date();
        var dateStrings = dates.getFullYear() + "-" + (dates.getMonth() + 1) + "-" + dates.getDate();

        _this.times = [dateString, dateStrings];
      },
      // 获取用户设备电费
      GetUserDeviceOperate() {
        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }
        let _this = this,
          AdminData = JSON.parse(Cookies.get('AdminData')),
          startDt = '',
          endDt = '';

        if (_this.times.length > 0) {
          startDt = _this.formDate(_this.times[0]);
          endDt = _this.formDate(_this.times[1])
        };
        // _this.$store.dispatch("setEnergyState", true);
        api({
          //这里是你自己的请求方式、url和data参数
          method: 'get',
          url: `api/YhjStatic/GetUserDevicePayLog?isAdmin=${AdminData.IsAdmin}&groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCode}&userDeviceName=${_this.userDeviceName}&mobilPhone=${_this.mobilPhone}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          // _this.$store.dispatch("setEnergyState", false);
          if (res.Success) {
            _this.DeviceOperateLists = res.Data;
            _this.TotalCount = res.TotalCount;
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },
      DeviceChange(value) {
        let _this = this;
        _this.pageIndex = value;
        _this.GetUserDeviceOperate();
      },
      DeviceSizeChange(value) {
        let _this = this;
        _this.pageIndex = 1;
        _this.pageSize = value;
        _this.GetUserDeviceOperate();
      },
      DeviceChange2(value) {
        let _this = this;
        _this.pageIndex2 = value;
        _this.GetUserDeviceElecFeeLogs();
      },
      DeviceSizeChange2(value) {
        let _this = this;
        _this.pageIndex2 = 1;
        _this.pageSize2 = value;
        _this.GetUserDeviceElecFeeLogs();
      },
      // 搜索
      inquireClick() {
        let _this = this;
        _this.pageIndex = 1;
        if(_this.SelectData == 1){
          _this.GetUserDeviceOperate();
        }else{
          _this.GetUserDeviceElecFeeLogs();
        }
      },
      // 导出充值明细
      exportClick() {
        let _this = this;
        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }
        let AdminData = JSON.parse(Cookies.get('AdminData')),
          startDt = '',
          endDt = '';

        if (_this.times.length > 0) {
          startDt = _this.formDate(_this.times[0]);
          endDt = _this.formDate(_this.times[1])
        };
        api({
          //这里是你自己的请求方式、url和data参数   /api/YhjStatic/Export_UserDevicePayLog
          method: 'get',
          url: `api/YhjStatic/Export_UserDevicePayLog?isAdmin=${AdminData.IsAdmin}&groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCode}&userDeviceName=${_this.userDeviceName}&mobilPhone=${_this.mobilPhone}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          if (res.Success) {
            window.location.href = res.Data;
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
      },


     //导出电费明细
     exportClick1(){
        let _this = this;
        if (!Cookies.get('AdminData')) {
          if (window.location.host == 'xed.hxpwr.com') {
            this.$router.push({
              name: 'xed_login'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          return;
        }
        let AdminData = JSON.parse(Cookies.get('AdminData')),
          startDt = '',
          endDt = '';

        if (_this.times.length > 0) {
          startDt = _this.formDate(_this.times[0]);
          endDt = _this.formDate(_this.times[1])
        };
        api({
          //这里是你自己的请求方式、url和data参数   /api/YhjStatic/Export_UserDeviceElecFeeLog
          method: 'get',
          url: `api/YhjStatic/Export_UserDeviceElecFeeLog?isAdmin=${AdminData.IsAdmin}&groupCode=${AdminData.GroupCode}&companyCode=${AdminData.CompanyCode}&departmentCode=${AdminData.DepartmentCode}&startDt=${startDt}&endDt=${endDt}&deviceCode=${_this.deviceCode}&userDeviceName=${_this.userDeviceName}&mobilPhone=${_this.mobilPhone}`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Authorization": Cookies.get('Token')
          }
        }, 'yhj').then(function(res) {
          if (res.Success) {
            window.location.href = res.Data;
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        });
     },
     exportClickOne(){
       let _this = this;
       if(_this.SelectData == 1){
         _this.exportClick();
       }else{
         _this.exportClick1();
       }
     },
      // 时间转换
      formDate(dateForm) {
        if (!dateForm) {
          return "";
        } else {
          var dateee = new Date(dateForm).toJSON();
          var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(
            /\.[\d]{3}Z/, '');
          return date;
        }
      },

    }
	}
</script>

<style scoped="scoped" lang="scss">
  /* @import url("./operation.css"); */
  @import "./operation_default.scss";
  @import "./operation.scss";
</style>



// WEBPACK FOOTER //
// src/components/report/deviceMoney/deviceMoney.vue